// import React,{Component} from "react";
// import {
//   Col
// } from "reactstrap";
// import "components/custom.css";
// import { arrayMove } from 'utils/arrayMove';
// import reactStringReplace from 'react-string-replace';
// import ReactHtmlParser from 'react-html-parser';
// import WordDefinitionModal from 'components/PracticeMaterial/PopUps/WordDefinitionModal';
// import ModalPopup from "components/PopUps/Modal";
// import FillInTheBlankExplanation from "components/PracticeMaterial/PopUps/FillInTheBlankExplanation";

// class ReadingBlank extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       question:"",
//       secondCount:1200,
//       questionId:"",
//       reset:false,
//       correctFlag:true,
//       resultObj:{},
//       answerData:{
//         answer: [],
//         correct: [],
//          selectedAnswer:""
//       },
//       wordDefinitionModalIsOpen: false,
//       modalDestroy: true,
//       selectedWord: "",
//       isModalOpen:false,
//       answer_explaination_key:"",
//       explanationModal: false,
//       };
//     this.questionPara = "";
//   }
//   componentDidMount = () => {
//   }
//   componentWillUnmount = () => {
//     clearInterval(this.state.intervalId);
//   }
//   onSortEnd = ({oldIndex, newIndex}) => {

//     this.setState({
//       items: arrayMove(this.state.items, oldIndex, newIndex),
//     });
//   };

//   allowDrop(event) {
//     event.preventDefault();
//   }

//   stopTest = () =>{
//     this.props.nextQuestion(this.state.resultObj);
//   }

//   drop1(event) {
//     this.props.showResult();
//     event.preventDefault();
//     let data = event.dataTransfer.getData("Text");
//     let no = event.dataTransfer.getData("no");
//     let temp = event.target.innerHTML;
//     let tempData = this.state.answerData.answer.slice();

//     if(temp === ""){
//      // this.setState({answerData:{'answer':[document.getElementById(event.target.id).getAttribute("no")],'correct':this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })}});

//       event.target.innerHTML = document.getElementById(data).innerHTML;
//       document.getElementById(data).innerHTML = temp;
//       let key = document.getElementById(event.target.id).getAttribute("no");
//       let tempData = this.state.answerData.answer.slice();
//       tempData[key] = event.target.innerHTML;

//       //this.setState({answerData:{'answer':tempData,'correct':this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })} });
//       this.props.submit({
//         'answer': this.gatherAnswer(),
//         'correct': this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })
//       }, true);
//       if(document.querySelectorAll('#'+data).length > 0){
//         //document.querySelectorAll('#'+data)[0].style.display='none';

//       }
//     }else{
//       //this.setState({answerData:{'answer':[document.getElementById(event.target.id).getAttribute("no")],'correct':this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })}});
//       let tempData = this.state.answerData.answer.slice();
//       event.target.innerHTML = document.getElementById(data).innerHTML;
//       document.getElementById(data).innerHTML = temp;
//       let key = document.getElementById(event.target.id).getAttribute("no");

//       tempData[key] = event.target.innerHTML;
//       console.log(tempData);
//       this.props.submit({
//         'answer': this.gatherAnswer(),
//         'correct': this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })
//       }, true);
//     }

//     this.setState({
//       resultObj: {
//         'answer': this.gatherAnswer(),
//         'correct': this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })
//       },
//       answerData:{
//         'answer': this.gatherAnswer(),
//         'correct':this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })
//       }
//     });
//     //document.querySelectorAll('.span2').forEach((t) => { if(t.innerHTML == '') { t.style.display="none"; } } );

//   }

//   gatherAnswer = () => {
//     const container = document.querySelectorAll('.response')[0];
//     const blanks = container.querySelectorAll(".span1");

//     let values = [];

//     // for compatibility purpose: with older method.
//     for (let k = 0; k < (blanks.length * 2); k++) {
//       if (k%2 === 0) {
//         values[k] = undefined;
//       } else {
//         values[k] = blanks[parseInt(k/2)].innerHTML;
//       }
//     }
//     return values;
//     // return container.innerHTML.replace(/<[^>]*>?/gm, 'x_x').split('x_x').map(function(i,x){ if(x%2 !=0) return i; })
//   }

//   updateCorrect = () => {
//     this.props.submit({'answer':[],'correct':this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })});
//     this.setState({correctFlag:false,resultObj:{'answer':[],'correct':this.props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; })}})
//   }

//   drop(event) {
//     event.preventDefault();
//     var data = event.dataTransfer.getData("Text");
//     var no = event.dataTransfer.getData("no");
//     var temp = event.target.innerHTML;
//     event.target.innerHTML = document.getElementById(data).innerHTML;
//     document.getElementById(data).innerHTML = temp;


//   }

//   showAnswer = () => {


//       if (!this.props.resultMode) {
//         let elem = document.querySelectorAll('.checkedSign');
//         for (var i = 0; i <= elem.length-1; i++) {
//           let id = elem[i].dataset.id;

//           if (elem[i].dataset.text.trim() == document.getElementById('item-'+id).textContent.trim()) {
//             elem[i].innerHTML= '<i className="fa fa-check" style="font-size:32px;color:green"></i>';
//           }else{
//             elem[i].innerHTML = `
//             <i className="fa fa-times" style="font-size:32px;color:red"></i>
//           `;
//           }
//         }
//       }
//   }

//   dragStart(event) {
//     event.dataTransfer.setData("Text", event.target.id);

//   }
//   onDrop(data) {
//     console.log(data);
//   }

//   static getDerivedStateFromProps(props, state) {
//     if (props.data) {
//       if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//         document.querySelectorAll('.span1').forEach((t) => { t.innerHTML="" } );
//         document.querySelectorAll('.span2').forEach((t) => { t.style.display="inline-block" } );
//         document.querySelectorAll('.span2').forEach((t) => { t.innerHTML=t.getAttribute('txt') } );
//         return {correctFlag:true,questionId: props.data.id,answerData:{'answer':[],'correct':[]},optionList:props.data.option};
//       }else{
//         if (!state.questionId) {
//           return {correctFlag:true,questionId: props.data.id,optionList:props.data.option};
//         }
//       }
//     }
//   }

//   openCloseWordDefinitionModal = (status, word="") => {
//     this.setState({
//       wordDefinitionModalIsOpen: status
//     }, () => {
//       if (!status) {
//         setTimeout(() => {
//           this.setState({
//             modalDestroy: true,
//             selectedWord: ""
//           });
//         }, 500);
//       } else {
//         this.setState({
//           modalDestroy: false,
//           selectedWord: word
//         });
//       }
//     });
//   }


//   wordClickHandle = (e, word) => {
//     e.preventDefault();
//     this.openCloseWordDefinitionModal(true, word);
//   }
//   toggleModal = () => {
//     this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
//   };


//   renderQuestionParagraph = () => {
//     let html = [];
//     this.questionPara.map((item, i) => {
//       if (typeof item === "string") {
//         item.split(" ").map((word, i) => {
//           html.push(
//             reactStringReplace(word, word, (match, i, o) => (
//               <span
//                 key={i}
//                 className="question-para-word speach-text"
//                 onClick={(e) => this.wordClickHandle(e, word)}
//               >{word}</span>
//             ))
//           );
//           html.push(" ");
//         });
//       } else {
//         html.push(item);
//       }
//     });

//     return html.map((item, i) => {
//       return (
//         <React.Fragment key={i}>
//           {item}
//         </React.Fragment>
//       )
//     });
//   }

//   toggleModalExplanation = () => {
//     this.setState({
//       explanationModal: !this.state.explanationModal
//     });
//   }


  
//   render() {
//     const { isModalOpen, modalContent } = this.state;
//     let question ="";
//     let optionList =[];
//     let correct =[];
//     if (this.props.restart) { 
//       this.props.restartQue();
//     }
//     if (this.props.answer) {
//       this.showAnswer();
//     }
//     if (this.props.stopRecording) {
//       this.stopTest();
//     }
//     if (this.props.data) {
//       if (this.state.correctFlag) {
//         this.updateCorrect();
//       }
//       question = this.props.data.question;
//       correct = question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 !=0) return i; });
//       this.questionPara = reactStringReplace(question.replace(/<[^>]*>?/gm, 'x_x').replace(/x_x(.*?)x_x/g,''), /(__add_blank__)/g, (match, i, o) => (
//         <>
//           <span
//             className="span1"
//             onDrop={this.drop1.bind(this)}
//             draggable="true"
//             onDragStart={this.dragStart}
//             no={i}
//             id={'item-'+i}
//             onDragOver={this.allowDrop}
//           ></span>
//           {this.props.answer && <span><span className="checkedSign" style={{display: (this.props.answer)?"inline-block":"none"}} data-id={i} data-text={correct[(i-1)/2]} ></span><span className="correct" >{correct[(i-1)/2]}</span>
//           {document.getElementById('item-'+i)?.textContent.trim()!=correct[(i-1)/2].trim() && (<span>
//             <i
//               className="fa fa-question cursor-pointer blanks explanation-icon" 
//               onClick={() => {
//                 this.setState({answer_explaination_key:correct[(i-1)/2]})
//                 this.toggleModalExplanation();
//               }}
//             ></i>
//             </span>)}</span>}
//         </>
//       ));
//       optionList = this.props.data.option;
//     }

//     if (this.state.reset) {
//       document.querySelectorAll('.span1').forEach((t) => { t.innerHTML="" } );
//       console.error("reset true");
//     }
//     let i=0;
//     const selectedAnswer = this.props.quen?.answer.split(",") || [];
//     return (
//       <>
//         <Col xs={12}>
//           <h4 className="infoText"></h4>
//         </Col>
//         <Col xs={12}>
//           <h5 className="response">
//             {this.props.data && !this.props.resultMode && this.renderQuestionParagraph()}
//           </h5>
//         </Col>
//         <Col xs={12}>{this.props.data && this.props.resultMode && <h4>Correct answer</h4>}<h5>{this.props.data && this.props.resultMode && ReactHtmlParser(question.replace(/<span[^>]*>?/g, '<b className="correct">').replace(/<[^>]*span>?/g, '</b>&nbsp;').replace(/__add_blank__/g, '')) }</h5></Col>
//         <Col xs={12}>{this.props.data && this.props.resultMode && <h4>Your response</h4>}
//         <h5>
//             {this.props.data &&
//               this.props.resultMode &&
//               reactStringReplace(
//                 question,
//                 /__add_blank__<span id='cAns'>(.*?)<\/span>/g,
//                 (match) => {
//                   return (
//                     <span key={i}>
//                       <b className="selected-option"></b>
//                       {!(match?.trim() === selectedAnswer?.[i++]?.trim()) && this.props.option_explaination.status &&  (
//                         <i
//                           className="fa fa-question cursor-pointer blanks explanation-icon"
//                           onClick={() => {
//                             this.setState({
//                               answer_explaination_key: match,
//                             });
//                             this.toggleModalExplanation();
//                           }}
//                         ></i>
//                       )}
//                     </span>
//                   );
//                 }
//               )}
//           </h5>
//         </Col>
//         <Col xs={12}>
//           <h3 className="question">{this.props.data && this.props.data.question_mcq}</h3>
//         </Col>
//         <Col lg={12} className="anwrsOptions">
//           {this.props.data && !this.props.resultMode && this.state.optionList.map((item, i) => {
//             return (
//               <span
//                 draggable="true"
//                 key={i}
//                 no="0"
//                 onDrop={this.drop.bind(this)}
//                 onDragOver={this.allowDrop}
//                 onDragStart={this.dragStart}
//                 className="span2"
//                 txt={item.options.trim()}
//                 id={'item-'+item.options.trim()}
//               >{item.options.trim()}</span>
//             )}
//           )}
//         </Col>
//         <Col lg={12}>&nbsp;</Col>

//         {!this.props.resultMode && !this.props.testMode &&
//           <Col xs={12}>
//             <div className="row shadowing">
//               <div className="word-definition">
//                 {!this.state.modalDestroy &&
//                   <WordDefinitionModal
//                     isOpen={this.state.wordDefinitionModalIsOpen}
//                     toggle={this.openCloseWordDefinitionModal}
//                     word={this.state.selectedWord}
//                     languages={this.props.languages}
//                   />
//                 }
//               </div>
//             </div>
//           </Col>
//         }
//         {isModalOpen && (
//           <ModalPopup
//             status={isModalOpen}
//             toggle={this.toggleModal}
//             showCloseBtn={true}
//             render={(toggle) => <span>
//                   <h2 className="modal-header modal-title">{
//                   `${this.state.answer_explaination_key.charAt(0).toUpperCase()}${this.state.answer_explaination_key.slice(1)}`
//                   }</h2>
//               <p className="mb-2 definition-text">
//                 {this.state.option_explaination?this.state.option_explaination[this.state.answer_explaination_key.toLowerCase()]:'Fetching Definitions...'}
//                 </p>
//             </span>}
//           />
//         )}

//         {this.state.explanationModal &&
//           <FillInTheBlankExplanation
//             isOpen={this.state.explanationModal}
//             title={`${this.state.answer_explaination_key.charAt(0).toUpperCase()}${this.state.answer_explaination_key.slice(1)}`}
//             // data={this.props.option_explaination?this.props.option_explaination[this.state.answer_explaination_key.toLowerCase()]:'Fetching Definitions...'}
//             data={this.props.option_explaination}
//             keyName={this.state.answer_explaination_key}
//             closeModal={this.toggleModalExplanation}


            
//           />
//         }
      
//       </>
//     );
//   }
// }

// export default ReadingBlank;

import React, { useState, useEffect, useRef } from "react";
import {Col} from "react-bootstrap";
import "components/custom.css";
import { arrayMove } from 'utils/arrayMove';
import reactStringReplace from 'react-string-replace';
import ReactHtmlParser from 'react-html-parser';
import WordDefinitionModal from 'components/PracticeMaterial/PopUps/WordDefinitionModal';
import ModalPopup from "components/PopUps/Modal";
import FillInTheBlankExplanation from "components/PracticeMaterial/PopUps/FillInTheBlankExplanation";

const ReadingBlank = (props) => {
  // const [question, setQuestion] = useState("");
  // const [secondCount, setSecondCount] = useState(1200);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [answerData, setAnswerData] = useState({
    answer: [],
    correct: [],
    selectedAnswer: ""
  });
  const [wordDefinitionModalIsOpen, setWordDefinitionModalIsOpen] = useState(false);
  const [modalDestroy, setModalDestroy] = useState(true);
  const [selectedWord, setSelectedWord] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [answer_explaination_key, setAnswerExplainationKey] = useState("");
  const [explanationModal, setExplanationModal] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [optionList, setOptionList] = useState([]);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [selectedOptionText, setSelectedOptionText] = useState("");
  const [selectedOptionId, setSelectedOptionId] = useState("");
  const [selectedOriginIndex, setSelectedOriginIndex] = useState(null);
  const [lastTap, setLastTap] = useState(0);
  const questionParaRef = useRef("");

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        document.querySelectorAll('.span1').forEach((t) => { t.innerHTML = "" });
        document.querySelectorAll('.span2').forEach((t) => { t.style.display = "inline-block" });
        document.querySelectorAll('.span2').forEach((t) => { t.innerHTML = t.getAttribute('txt') });
        setCorrectFlag(true);
        setQuestionId(props.data.id);
        setAnswerData({ 'answer': [], 'correct': [] });
        setOptionList(props.data.option);
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
          setOptionList(props.data.option);
        }
      }
    }
  }, [props.data, props.restart, questionId]);

  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);

  useEffect(() => {
    if (props.answer) {
      showAnswer();
    }
  }, [props.answer]);

  useEffect(() => {
    if (props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording]);

  useEffect(() => {
    if (props.data && correctFlag) {
      updateCorrect();
    }
  }, [props.data, correctFlag]);

    // Detect touch device (mobile/tablet)
  useEffect(() => {
    const checkTouch = () => {
      setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
    };
    checkTouch();
    window.addEventListener('resize', checkTouch);
    return () => window.removeEventListener('resize', checkTouch);
  }, []);

  // Only used on mobile/tablet
  const handleOptionClick = (text, id, originIndex) => {
    if (props.answer || !isTouchDevice) return;

    // Clear previous selection highlight
    document.querySelectorAll('.span2.selected-mobile').forEach(el =>
      el.classList.remove('selected-mobile')
    );

    setSelectedOptionText(text.trim());
    setSelectedOptionId(id);
    setSelectedOriginIndex(originIndex);

    // Highlight current
    const el = document.getElementById(id);
    if (el) el.classList.add('selected-mobile');
  };

  // Place selected word into blank (mobile/tablet)
  const handleBlankClick = (e, blankIndex) => {
    if (!isTouchDevice) return; // Only run on touch devices

    // Handle double tap detection
    handleDoubleTap(e, blankIndex);

    const blankEl = e.currentTarget;
    const currentText = blankEl.innerHTML.trim();

    if (props.answer) {
      // After submit: show explanation if wrong
      const correctAnswers = props.data.question
        .replace(/<[^>]*>?/gm, 'x_x')
        .split('x_x')
        .filter((_, i) => i % 2 !== 0);
      const correctText = correctAnswers[Math.floor(blankIndex / 2)];

      if (currentText !== correctText.trim()) {
        setAnswerExplainationKey(correctText);
        setExplanationModal(true);
      }
      return;
    }

    // Before submit: place or remove
    if (selectedOptionText && !currentText) {
      // Fill empty blank
      blankEl.innerHTML = selectedOptionText;
      blankEl.setAttribute('data-source', selectedOptionId);
      if (selectedOriginIndex !== null) {
        blankEl.setAttribute('data-origin', selectedOriginIndex);
      }

      // Clear option text, keep the box visible (like practice mode)
      const optEl = document.getElementById(selectedOptionId);
      if (optEl) optEl.innerHTML = "";

      // Clear selection
      setSelectedOptionText("");
      setSelectedOptionId("");
      setSelectedOriginIndex(null);
      document.querySelectorAll('.span2.selected-mobile').forEach(el =>
        el.classList.remove('selected-mobile')
      );

      submitCurrentAnswer();
    }
  };

  // Handle double tap for touch devices
  const handleDoubleTap = (e, blankIndex) => {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - lastTap;
    
    if (tapLength < 500 && tapLength > 0) {
      // console.log('Double tap detected');
      removeTextFromBlank(e, blankIndex);
    }
    setLastTap(currentTime);
  };

  // Double click to remove word from blank (works on all devices)
  const handleBlankDoubleClick = (e, blankIndex) => {
    // console.log('Double click detected');
    e.preventDefault();
    removeTextFromBlank(e, blankIndex);
  };

  // Common function to remove text from blank
  const removeTextFromBlank = (e, blankIndex) => {
    if (props.answer) return; // Don't allow after submit

    const blankEl = e.currentTarget;
    const currentText = blankEl.innerHTML.trim();

    if (currentText) {
      blankEl.innerHTML = "";

      // Put word back into its ORIGINAL box using stable origin index
      const originIndex = blankEl.getAttribute('data-origin');
      const originalEl = originIndex !== null
        ? document.getElementById(`item-opt-${originIndex}`)
        : null;

      if (originalEl) {
        const occupant = originalEl.innerHTML.trim();
        if (occupant && occupant !== currentText) {
          // Original box has another word — move that word to an empty slot first
          const options = props.data?.option || [];
          for (let i = 0; i < options.length; i++) {
            const optEl = document.getElementById(`item-opt-${i}`);
            if (optEl && optEl.innerHTML.trim() === "") {
              optEl.innerHTML = occupant;
              break;
            }
          }
        }
        originalEl.innerHTML = currentText;
      }
      blankEl.removeAttribute('data-source');
      blankEl.removeAttribute('data-origin');

      submitCurrentAnswer();
    }
  };

  const submitCurrentAnswer = () => {
    if (!props.data) return;

    props.showResult?.();

    const correct = props.data.question
      .replace(/<[^>]*>?/gm, 'x_x')
      .split('x_x')
      .filter((_, i) => i % 2 !== 0);

    const prepared = {
      answer: gatherAnswer(),
      correct
    };

    props.submit?.(prepared, true);
    setResultObj(prepared);
    setAnswerData(prepared);
  };

  // const onSortEnd = ({ oldIndex, newIndex }) => {
  //   // Note: 'items' state is not defined in original, keeping for compatibility
  //   // setItems(arrayMove(items, oldIndex, newIndex));
  // };

  const allowDrop = (event) => {
    event.preventDefault();
  };

  const stopTest = () => {
    props.nextQuestion(resultObj);
  };

  const drop1 = (event) => {
    props.showResult();
    event.preventDefault();
    let data = event.dataTransfer.getData("Text");
    let dropName = data.split("-")[1];
    let no = event.dataTransfer.getData("no");
    let temp = event.target.innerHTML;
    let tempData = answerData.answer.slice();
    console.log(data,optionList,dropName); 
    if (temp === "") {
      const sourceEl = document.getElementById(data);
      const sourceOrigin = sourceEl.getAttribute('data-origin');
      event.target.innerHTML = sourceEl.innerHTML;
      sourceEl.innerHTML = temp;
      event.target.setAttribute('data-source', data);
      if (sourceOrigin !== null) {
        event.target.setAttribute('data-origin', sourceOrigin);
      }
      let key = document.getElementById(event.target.id).getAttribute("no");
      let tempData = answerData.answer.slice();
      tempData[key] = event.target.innerHTML;

      props.submit({
        'answer': gatherAnswer(),
        'correct': props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 != 0) return i; })
      }, true);

      if (document.querySelectorAll('#' + data).length > 0) {
        //document.querySelectorAll('#'+data)[0].style.display='none';
      }
    } else {
      let tempData = answerData.answer.slice();
      // Swap: blank gets new word, source gets old word (matches practice mode)
      const sourceEl = document.getElementById(data);
      const sourceOrigin = sourceEl.getAttribute('data-origin');
      const targetOrigin = event.target.getAttribute('data-origin');
      event.target.innerHTML = sourceEl.innerHTML;
      sourceEl.innerHTML = temp;
      event.target.setAttribute('data-source', data);
      if (sourceOrigin !== null) event.target.setAttribute('data-origin', sourceOrigin);
      if (targetOrigin !== null) sourceEl.setAttribute('data-origin', targetOrigin);
      let key = document.getElementById(event.target.id).getAttribute("no");

      tempData[key] = event.target.innerHTML;
      console.log(tempData);
      props.submit({
        'answer': gatherAnswer(),
        'correct': props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 != 0) return i; })
      }, true);
    }

    setResultObj({
      'answer': gatherAnswer(),
      'correct': props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 != 0) return i; })
    });
    
    setAnswerData({
      'answer': gatherAnswer(),
      'correct': props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 != 0) return i; })
    });
  };

  const gatherAnswer = () => {
    const container = document.querySelectorAll('.response')[0];
    const blanks = container.querySelectorAll(".span1");

    let values = [];

    // for compatibility purpose: with older method.
    for (let k = 0; k < (blanks.length * 2); k++) {
      if (k % 2 === 0) {
        values[k] = undefined;
      } else {
        values[k] = blanks[parseInt(k / 2)].innerHTML;
      }
    }
    return values;
  };

  const updateCorrect = () => {
    props.submit({ 'answer': [], 'correct': props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 != 0) return i; }) });
    setCorrectFlag(false);
    setResultObj({ 'answer': [], 'correct': props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 != 0) return i; }) });
  };

  const drop = (event) => {
    event.preventDefault();
    var data = event.dataTransfer.getData("Text");
    var no = event.dataTransfer.getData("no");
    var temp = event.target.innerHTML;
    const sourceEl = document.getElementById(data);
    const sourceOrigin = sourceEl.getAttribute('data-origin');
    const targetOrigin = event.target.getAttribute('data-origin');
    event.target.innerHTML = sourceEl.innerHTML;
    sourceEl.innerHTML = temp;
    if (sourceOrigin !== null) event.target.setAttribute('data-origin', sourceOrigin);
    if (targetOrigin !== null) sourceEl.setAttribute('data-origin', targetOrigin);
    // console.log(data,no,temp,optionList);
    // const droppedText = event.dataTransfer.getData("text/plain");
    // setOptionList(prev => prev.filter(item => item.trim() !== droppedText));
  };

  const showAnswer = () => {
    if (!props.resultMode) {
      let elem = document.querySelectorAll('.checkedSign');
      for (var i = 0; i <= elem.length - 1; i++) {
        let id = elem[i].dataset.id;

        if (elem[i].dataset.text.trim() == document.getElementById('item-' + id).textContent.trim()) {
          elem[i].innerHTML = '<i className="fa fa-check" style="font-size:32px;color:green"></i>';
        } else {
          elem[i].innerHTML = `
            <i className="fa fa-times" style="font-size:32px;color:red"></i>
          `;
        }
      }
    }
  };

  const dragStart = (event) => {
    event.dataTransfer.setData("Text", event.target.id);
  };

  const onDrop = (data) => {
    console.log(data);
  };

  const openCloseWordDefinitionModal = (status, word = "") => {
    setWordDefinitionModalIsOpen(status);
    if (!status) {
      setTimeout(() => {
        setModalDestroy(true);
        setSelectedWord("");
      }, 500);
    } else {
      setModalDestroy(false);
      setSelectedWord(word);
    }
  };

  const wordClickHandle = (e, word) => {
    e.preventDefault();
    openCloseWordDefinitionModal(true, word);
  };

  const toggleModal = () => {
    setIsModalOpen(prevState => !prevState);
  };

  const renderQuestionParagraph = () => {
    let html = [];
    questionParaRef.current.map((item, i) => {
      if (typeof item === "string") {
        item.split(" ").map((word, i) => {
          html.push(
            reactStringReplace(word, word, (match, i, o) => (
              <span
                key={i}
                className="question-para-word speach-text"
                onClick={(e) => wordClickHandle(e, word)}
                id="speech-text"
              >{word}</span>
            ))
          );
          html.push(" ");
        });
      } else {
        html.push(item);
      }
    });

    return html.map((item, i) => {
      return (
        <React.Fragment key={i}>
          {item}
        </React.Fragment>
      )
    });
  };

  const toggleModalExplanation = () => {
    setExplanationModal(prev => !prev);
  };

  let questionText = "";
  let optionListRender = [];
  let correct = [];
  
  if (props.data) {
    questionText = props.data.question;
    correct = questionText.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 != 0) return i; });
    questionParaRef.current = reactStringReplace(questionText.replace(/<[^>]*>?/gm, 'x_x').replace(/x_x(.*?)x_x/g, ''), /(__add_blank__)/g, (match, i, o) => (
      <>
        <span
          className="span1"
          onDrop={drop1}
          draggable="true"
          onDragStart={dragStart}
          onClick={(e) => handleBlankClick(e, i)}
          onDoubleClick={(e) => handleBlankDoubleClick(e, i)}
          no={i}
          id={'item-' + i}
          onDragOver={allowDrop}
          style={{ cursor: 'pointer' }}
        ></span>
        {props.answer && <span><span className="checkedSign" style={{ display: (props.answer) ? "inline-block" : "none" }} data-id={i} data-text={correct[(i - 1) / 2]} ></span><span className="correct" >{correct[(i - 1) / 2]}</span>
          {document.getElementById('item-' + i)?.textContent.trim() != correct[(i - 1) / 2].trim() && (<span>
            <i
              className="fa fa-question cursor-pointer blanks explanation-icon"
              onClick={() => {
                setAnswerExplainationKey(correct[(i - 1) / 2]);
                toggleModalExplanation();
              }}
            ></i>
          </span>)}</span>}
      </>
    ));
    optionListRender = props.data.option;
  }

  if (reset) {
    document.querySelectorAll('.span1').forEach((t) => { t.innerHTML = "" });
    console.error("reset true");
  }
  
  let i = 0;
  const selectedAnswer = props.quen?.answer.split(",") || [];

  // console.log("inside reading blank");

  return (
    <>
      {!props.resultMode && 
        <Col xs={12}>
          <h4 className="infoText"></h4>
        </Col>
      }
      <Col xs={12}>
        <h5 className="response">
          {props.data && !props.resultMode && renderQuestionParagraph()}
        </h5>
      </Col>
      <Col xs={12}>
        {props.data && props.resultMode && <h4 className={props.resultMode ? "mt-0" : ""} >Correct answer</h4>}
        <h5 className={props.resultMode ? "reading-text text-start":""}>
          {props.data &&
            props.resultMode &&
            ReactHtmlParser(
              questionText
                .replace(/<span[^>]*>?/g, '<b className="correct">')
                .replace(/<[^>]*span>?/g, "</b>&nbsp;")
                .replace(/__add_blank__/g, "")
            )}
        </h5>
      </Col>
      <Col xs={12}>
        {props.data && false && <h4>Your response</h4>}
        {/* <h5>
          {props.data &&
            props.resultMode &&
            reactStringReplace(
              questionText,
              /__add_blank__<span id='cAns'>(.*?)<\/span>/g,
              (match) => {
                return (
                  <span key={i}>
                    <b className="selected-option"></b>
                    {!(match?.trim() === selectedAnswer?.[i++]?.trim()) && props.option_explaination.status && (
                      <i
                        className="fa fa-question cursor-pointer blanks explanation-icon"
                        onClick={() => {
                          setAnswerExplainationKey(match);
                          toggleModalExplanation();
                        }}
                      ></i>
                    )}
                  </span>
                );
              }
            )}
        </h5> */}
        <h5>
          {props.data &&
            false &&
            reactStringReplace(
              questionText,
              /__add_blank__<span id='cAns'>(.*?)<\/span>/g,
              (match, i) => {
                const answerIndex = (i - 1) / 2;

                const correctText = correct[answerIndex];
                const selectedText = selectedAnswer?.[answerIndex];

                const isNotSelected = !selectedText || selectedText === "-";
                const isCorrect = selectedText === correctText;
                const isWrong =
                  selectedText && selectedText !== "-" && !isCorrect;

                return (
                  <span key={i} className="result-blank">
                    {/* ✅ Correct */}
                    {isCorrect && (
                      <span className="pill pill-correct">
                        {selectedText}
                        <i className="fa fa-check icon-right" />
                      </span>
                    )}

                    {/* ❌ Wrong */}
                    {isWrong && (
                      <>
                        <span className="pill pill-wrong">
                          {selectedText}
                          <i className="fa fa-times icon-right" />
                        </span>
                       {props?.option_explaination.status && <i
                          className="fa fa-question-circle explanation-icon"
                          onClick={() => {
                            setAnswerExplainationKey(correctText);
                            toggleModalExplanation();
                          }}
                        /> }
                        
                      </>
                    )}

                    {/* 🔵 Not selected */}
                    {isNotSelected && (
                      <span className="pill pill-missed">{correctText}</span>
                    )}
                  </span>
                );
              }
            )}
        </h5>
      </Col>
      <Col xs={12}>
        <h3 className="question">{props.data && props.data.question_mcq}</h3>
      </Col>
      {props.data && !props.resultMode && (
        <Col lg="auto" className="anwrsOptions mx-3">
          {props.data.option.map((item, i) => {
            const isUsed = !optionList.some(opt => opt.options.trim() === item.options.trim());
            return (
              <span
                key={i}
                draggable={!isUsed ? "true" : "false"}
                no="0"
                onDrop={!isUsed ? drop : undefined}
                onDragOver={!isUsed ? allowDrop : undefined}
                onDragStart={!isUsed ? dragStart : undefined}
                onClick={!isUsed ? (e) => {
                  const el = e.currentTarget;
                  handleOptionClick(
                    el.textContent.trim(),
                    el.id,
                    Number(el.dataset.origin)
                  );
                } : undefined
                }
                className="span2 mock-header-gap"
                txt={item.options.trim()}
                id={`item-opt-${i}`}
                data-origin={i}
                style={isUsed ? { color: 'transparent', cursor: 'default' } : {}}
              >
                {item.options.trim()}
              </span>
            );
          })}
        </Col>
      )}
      <Col lg={12}>&nbsp;</Col>

      {!props.resultMode && !props.testMode && (
        <Col xs={12}>
          <div className="row shadowing">
            <div className="word-definition">
              {!modalDestroy && (
                <WordDefinitionModal
                  isOpen={wordDefinitionModalIsOpen}
                  toggle={openCloseWordDefinitionModal}
                  word={selectedWord}
                  languages={props.languages}
                />
              )}
            </div>
          </div>
        </Col>
      )}
      {isModalOpen && (
        <ModalPopup
          status={isModalOpen}
          toggle={toggleModal}
          showCloseBtn={true}
          render={(toggle) => (
            <span>
              <h2 className="modal-header modal-title">{`${answer_explaination_key
                .charAt(0)
                .toUpperCase()}${answer_explaination_key.slice(1)}`}</h2>
              <p className="mb-2 definition-text">
                {props.option_explaination
                  ? props.option_explaination[
                      answer_explaination_key.toLowerCase()
                    ]
                  : "Fetching Definitions..."}
              </p>
            </span>
          )}
        />
      )}

      {explanationModal && (
        <FillInTheBlankExplanation
          isOpen={explanationModal}
          title={`${answer_explaination_key
            .charAt(0)
            .toUpperCase()}${answer_explaination_key.slice(1)}`}
          data={props.option_explaination}
          keyName={answer_explaination_key}
          closeModal={toggleModalExplanation}
        />
      )}
    </>
  );
};

export default ReadingBlank;
